import apiClient from '@skygroup/shared/API/apiClient';
import endpoints from '@skygroup/shared/API/endpoints';
import { useCallback } from 'react';

export const useMembershipAuth = () => {
  const isAuthenticated = useCallback(() => {
    const authDataString = localStorage.getItem('membershipUser');
    if (!authDataString) return false;
    try {
      const authData = JSON.parse(authDataString);
      if (!authData.expirationDate) return false;
      return new Date(authData.expirationDate) > new Date();
    } catch (error) {
      return false;
    }
  }, []);

  const membershipLogin = useCallback(async (id: string, phone: string, auth_type: string) => {
    const response = await apiClient.post(endpoints.AUTH.lOGINOTP, {
      id,
      phone,
      auth_type,
    });
    const sessionId = response.data.data.session_id;
    console.log(response)
    if (response.data.status != "success") {
       throw new Error(response.data?.data?.message);
    }
    return sessionId;
  }, []);

  const verifyOTPFn = useCallback(async (sessionId: string, code: string) => {
   
    const response = await apiClient.post(endpoints.AUTH.VERIFYOTP, {
      session_id: sessionId,
      code,
    });
    if (response.data.status != "success")
      throw new Error('');
    
    console.log(response)
    console.log(response.data.data.membershipUser)
     const simulatedResponse = {
      ...response.data.data.membershipUser,
      expirationDate: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toISOString(),
    }; 
    return simulatedResponse;

  }, []);

  return { isAuthenticated, membershipLogin, verifyOTPFn };
};